import type { EpmMetricName } from '@shared_types/metrics/epm_metrics'
import { allEpmMetricNames } from '@shared_types/metrics/epm_metrics'
import type { Metric } from '@shared_types/vessel_data'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_GENERATORS, UPDATE_GENERATORS } from '../actions'

const initialState = initializeMetrics(allEpmMetricNames)

type BatteryPayload = Record<EpmMetricName, Metric>

export default function init (previousState = initialState, { type, payload }: { type: string; payload: BatteryPayload }) {
  if (type === LOAD_GENERATORS || type === UPDATE_GENERATORS) {
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
